/**
 * @generated SignedSource<<192b8380fab35de61d7f353e88be4f11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
export type BookingType = "DINING" | "LESSON" | "STANDARD";
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
export type PromoCodeCategory = "ACTIVITY_MANAGEMENT" | "GOLF" | "LESSON";
export type PromoCodeDiscountType = "FIXED" | "PERCENTAGE";
import { FragmentRefs } from "relay-runtime";
export type promoCodeAnalytics_booking$data = {
  readonly appliedPromoCode: {
    readonly category: PromoCodeCategory;
    readonly code: string;
    readonly discountAmount: number;
    readonly discountType: PromoCodeDiscountType;
  } | null | undefined;
  readonly promoCodeOrders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"getAggregatedOrderFinancialSummary_order">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startSlot: {
    readonly agenda: {
      readonly date: string;
      readonly facility: {
        readonly department: {
          readonly type: DepartmentType;
        } | null | undefined;
        readonly name: string;
      };
    };
  } | null | undefined;
  readonly type: BookingType;
  readonly " $fragmentType": "promoCodeAnalytics_booking";
};
export type promoCodeAnalytics_booking$key = {
  readonly " $data"?: promoCodeAnalytics_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"promoCodeAnalytics_booking">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "promoCodeAnalytics_booking"
};

(node as any).hash = "e389a699cc142f7678bf5377eebd9ffc";

export default node;
